import "lazysizes";

import Swup from "swup";
import SwupScrollPlugin from "@swup/scroll-plugin";
import SwupBodyClassPlugin from "@swup/body-class-plugin";
import List from "list.js";

import { toggleView } from "./components/toggle-view";
import { collapsibleText } from "./components/collapsible-text";
import { floatingImages } from "./components/floating-images";
import Lightbox from "./components/lightbox";

window.main = window.main || {};

let isHomepage = false;
let isProjectPage = false;
let isTouchDevice = false;
let introRan = false;

function checks() {
  function checkIfTouchDevice() {
    return (
      true ==
      ("ontouchstart" in window ||
        (window.DocumentTouch && document instanceof DocumentTouch))
    );
  }

  if (checkIfTouchDevice() === true) {
    document.body.classList.add("is-touch");
    document.body.classList.add("is-mobile-device");
    isTouchDevice = true;
  } else {
    isTouchDevice = false;
  }

  if (document.body.classList.contains("page-home")) {
    isHomepage = true;
  } else {
    isHomepage = false;
  }

  if (document.body.classList.contains("page-project")) {
    isProjectPage = true;
  } else {
    isProjectPage = false;
  }

}

function initSortableList() {
  const projectsList = document.getElementById("projects-list");
  if (projectsList) {
    const options = { valueNames: ["title", "typology", "client", "year"] };
    new List("projects-list", options);
  }
}

function setupPlugins() {
  function initSwup() {
    const options = {
      animationSelector: '[class*="transition-fade"]',
      animateHistoryBrowsing: true,
      containers: ["#main", ".js-header"],
      plugins: [
        new SwupScrollPlugin({
          animateScroll: false,
        }),
        new SwupBodyClassPlugin({
          prefix: "page-",
        }),
      ],
    };

    const swup = new Swup(options);

    swup.on("contentReplaced", () => {
      checks();
      swupReload();
      swupActiveLinks(); // trigger after swup
    });
  }

  initSwup();
}

function swupActiveLinks() {
  let currentPath = window.location.pathname;
  let links = document.querySelectorAll("nav a"); // <- put your link selector here
  for (const link of links) {
    let linkPath = new URL(link.href).pathname;
    link.ariaCurrent = linkPath == currentPath ? "page" : false;
  }
}

function swupReload() {

  document.body.setAttribute("data-menu-open", "false");
  document.body.classList.remove("no-scroll");
  isNavToggled = false;

  initSortableList();
  toggleView();
  collapsibleText();

  if (!isTouchDevice) {
    floatingImages();
  }

  if (isProjectPage) {
    const lb = new Lightbox({
      selector: '[data-rel="aiLightbox"]', // string
      lazyload: true, // boolean
      arrows: true, // boolean
      counter: true, // boolean
      slideSpeed: 500, //number(ms)
    });
  }

}

function init() {
  if (history.scrollRestoration) {
    history.scrollRestoration = "manual";
  }

  const introelement = document.getElementById("intro");
  if (typeof introelement != "undefined" && introelement != null) {
    intro(introRan, isHomepage);
    introRan = true;
  }

  initSortableList();
  toggleView();
  collapsibleText();
  if (!isTouchDevice) {
    floatingImages();
  }

  if (isProjectPage) {
    const lb = new Lightbox({
      selector: '[data-rel="aiLightbox"]', // string
      lazyload: true, // boolean
      arrows: true, // boolean
      counter: true, // boolean
      slideSpeed: 500, //number(ms)
    });
  }

  function setOffsetPosition() {
    const logoElement = document.querySelector(".js-logo-part");
    if (logoElement) {
      const logoStyles = getComputedStyle(logoElement);
      const logoHeight = logoElement.offsetHeight + parseFloat(logoStyles.marginTop) + parseFloat(logoStyles.marginBottom);
      //Set 'top' of sticky element to the offsetheight of logo
      const elements = document.querySelectorAll(".js-stick-offset-logo");
      elements.forEach((element) => {
        element.style.top = logoHeight + "px";
      });
    }
  }

  function fadeOnScroll() {
    const logoElement = document.querySelector(".js-logo-part");
    if (logoElement) {
      const logoHeight = document.querySelector(".js-logo-part").offsetHeight;
      const elements = document.querySelectorAll(".js-fade-on-scroll");
      elements.forEach((element) => {
        const scrollPosition = window.scrollY;
        const opacity = 1 - scrollPosition / (logoHeight / 1.5);
        element.style.opacity = opacity;
      });
    }
  }

  setOffsetPosition();
  window.addEventListener("resize", setOffsetPosition);
  window.addEventListener("scroll", fadeOnScroll);

  function projectNav() {
    const projectCover = document.querySelector(".js-project-cover");
    const projectTitle = document.querySelector(".js-project-title");
    window.addEventListener("scroll", () => {
      const scrollPosition = window.scrollY;
      const coverTop = projectCover.getBoundingClientRect().top + 175;
      if (scrollPosition > coverTop) {
        projectTitle.style.opacity = "1";
      } else {
        projectTitle.style.opacity = "0";
      }
    });
  }

  if (isProjectPage) {
    projectNav();
  }

}

checks();
// setupPlugins();
init();
